import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewMerchantAirtableModal = _resolveComponent("NewMerchantAirtableModal")!
  const _component_NewMerchantMondayModal = _resolveComponent("NewMerchantMondayModal")!
  const _component_NewMerchantGooglesheetsModal = _resolveComponent("NewMerchantGooglesheetsModal")!
  const _component_NewMerchantExcelModal = _resolveComponent("NewMerchantExcelModal")!
  const _component_MerchantFieldMapModal = _resolveComponent("MerchantFieldMapModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.formType == 'Airtable')
      ? (_openBlock(), _createBlock(_component_NewMerchantAirtableModal, {
          key: 0,
          onOnHandleCompleted: _ctx.handleCompletedImport
        }, null, 8, ["onOnHandleCompleted"]))
      : _createCommentVNode("", true),
    (_ctx.formType == 'Monday')
      ? (_openBlock(), _createBlock(_component_NewMerchantMondayModal, {
          key: 1,
          onOnHandleCompleted: _ctx.handleCompletedImport
        }, null, 8, ["onOnHandleCompleted"]))
      : _createCommentVNode("", true),
    (_ctx.formType == 'Google Sheets')
      ? (_openBlock(), _createBlock(_component_NewMerchantGooglesheetsModal, {
          key: 2,
          onOnHandleCompleted: _ctx.handleCompletedImport
        }, null, 8, ["onOnHandleCompleted"]))
      : _createCommentVNode("", true),
    (_ctx.formType == 'Excel')
      ? (_openBlock(), _createBlock(_component_NewMerchantExcelModal, {
          key: 3,
          onOnHandleCompleted: _ctx.handleCompletedImport
        }, null, 8, ["onOnHandleCompleted"]))
      : _createCommentVNode("", true),
    _createVNode(_component_MerchantFieldMapModal, {
      formType: _ctx.formType,
      dataFields: _ctx.dataFields,
      isLoading: _ctx.isLoading,
      isCompleted: _ctx.isCompleted,
      onOnHandleFieldMap: _ctx.handleFieldMap
    }, null, 8, ["formType", "dataFields", "isLoading", "isCompleted", "onOnHandleFieldMap"])
  ]))
}